<template>
    <modal id="create-property-modal"
            title="Select a method"
            :visible="show"          
            @shown="onModalShown"
            ok-title="Proceed"
            @ok="createProperty"
            class="lx-global-modal"
            no-fade>
        <div class="funkyradio">
            <div class="funkyradio-primary">
                <input type="radio" name="property-create-modal-radio" id="create_property_airbnb" @click="mode='create_property_airbnb'">
                <label for="create_property_airbnb">Import From Airbnb</label>
            </div>				
            
            <div class="funkyradio-success" v-if="clonePropertyOptions.length > 0">
                <input type="radio" name="property-create-modal-radio" id="create_property_clone"  @click="mode='create_property_clone'">
                <label for="create_property_clone">Clone Property</label>
                <b-form-select v-if="mode == 'create_property_clone'" v-model="propertyId" :options="clonePropertyOptions"></b-form-select>						
                <form-checkbox 
                    v-if="mode == 'create_property_clone'" 
                    class="include-reviews-button" 
                    v-model="includeReviews"
                >
                    Include Reviews
                </form-checkbox>
            </div>
            
            <div class="funkyradio-danger">
                <input type="radio" name="property-create-modal-radio" id="create_property_wizard" checked="" @click="mode='create_property_wizard'">
                <label for="create_property_wizard">Property Creation Wizard</label>
            </div>
     
        </div>
    </modal>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Modal from '../../generic/modal/modal.vue';
    import FormCheckbox from '../../generic/form-checkbox/form-checkbox.vue';
    
    export default {
        name: 'CreatePropertyModal',
        components: { Modal, FormCheckbox },
        props: {
            show: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                propertyId: null,
                mode: 'create_property_wizard',
                includeReviews: false,
            }
        },
        methods: {
            onModalShown(event) {
                this.$nextTick(() => {
                    this.mode = 'create_property_wizard';
                    document.getElementById('create_property_wizard').click();
                });
                (async () => {
                    try {
                        await this.$store.dispatch('header/fetchClonePropertyOptions');
                    } catch (err) {
                        console.log(`Could not fetch property options data in header nav bar: ${err}`);
                    }
                    this.propertyId = this.clonePropertyOptions[0].value;                    
                })();                    
            }, 
            createProperty() {
                if (this.mode == 'create_property_airbnb') {
                    window.location = '/app/airbnb-import/';
                }
                else if (this.mode == 'create_property_wizard') {
                    window.location = '/app/property/create-cottage';
                }
                else if (this.mode == 'create_property_clone' && this.propertyId != null) {
                    window.location =
                        `/app/property/property/${this.propertyId}/clone-property/` +
                        `?includeReviews=${this.includeReviews}`;
                }

            },            
        },
        computed: {
            ...mapGetters('header', [
                'clonePropertyOptions',
            ]),
        },
        
    }
</script>

<style lang="scss">
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/mixins/_breakpoints.scss';

.include-reviews-button {
    .custom-control-label:before, .custom-control-label:after {
        margin-left: 0.2em !important;
    }
    .custom-control-label {
        border: 0 !important;
        padding-left: 0.2em !important;
    }
    padding-top: 0.4em !important;
}
</style>

